import { render } from "./TableLite.vue?vue&type=template&id=4b732ca0&scoped=true"
import script from "./TableLite.vue?vue&type=script&lang=js"
export * from "./TableLite.vue?vue&type=script&lang=js"

import "./TableLite.vue?vue&type=style&index=0&id=4b732ca0&scoped=true&lang=css"

import exportComponent from "/home/douglas/Documents/Rwi/surefooted-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b732ca0"]])

export default __exports__